import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Frame } from '../../components/shell/AppShell';
import PageHeader from '../../components/shell/PageHeader';
import UserManagement from '../../components/admin/UserManagement';
import MemberRegistry from '../../components/admin/MemberRegistry';
import adminArt from '../../assets/bg/founder-admin.webp';

/**
 * Members: the operational accounts, and -- for the Founder only -- the
 * Registry beside them. Two datasets, two views; the switch says so.
 *
 * The Registry is not loaded until it is opened, and opening it still asks
 * for the password again (MemberRegistry's own gate, unchanged). An operator
 * never sees the switch: their view is the list of members assigned to them,
 * read-only, as the server scopes it.
 */
const Members = () => {
  const { user } = useAuth();
  const founder = user?.role === 'superadmin';
  const [view, setView] = useState('users');

  const Tab = ({ id, children }) => (
    <button
      type="button"
      role="tab"
      aria-selected={view === id}
      onClick={() => setView(id)}
      className={[
        'min-h-[40px] flex-1 rounded-lg px-4 text-sm transition-colors',
        view === id ? 'bg-primary/15 text-primary' : 'text-muted-foreground hover:text-foreground',
      ].join(' ')}
      data-testid={`members-${id}-tab`}
    >
      {children}
    </button>
  );

  return (
    <Frame user={user} background={adminArt} scrim={0.55} activeKey="members">
      <div data-testid="members-page">
        <PageHeader
          title="Members"
          subtitle={founder ? 'Users and Registry' : 'Members assigned to you'}
        />
        <div className="mx-auto max-w-5xl px-4 pb-6 pt-3 space-y-4">
          {founder && (
            <div role="tablist" className="mx-auto flex max-w-xs gap-1 rounded-xl border border-border bg-card/85 p-1 backdrop-blur-sm">
              <Tab id="users">Users</Tab>
              <Tab id="registry">Registry</Tab>
            </div>
          )}
          <div className="rounded-xl border border-border bg-card/90 p-3 md:p-5 backdrop-blur-sm">
            {founder && view === 'registry' ? <MemberRegistry /> : <UserManagement />}
          </div>
        </div>
      </div>
    </Frame>
  );
};

export default Members;
